import React, { Component } from 'react'
import firebase from 'firebase';
import Alert from 'react-s-alert';
import './estilo.css'
import TaxiIcon from '../../img/taxiUbicacion1.png'
import PrivadoIcon from '../../img/privadoUbicacion.png'
import MicroIcon from '../../img/microbus.png'
import CoasterIcon from '../../img/coaster.png'
import { getDate } from 'date-fns';
import moment from 'moment';
import { Pulse } from 'react-preloading-component';

class AsignaViaje extends Component {
    constructor(props) {
        super(props);
        this.state = {
            viajesD: [],
            bases: [],
            baseFill: '',
            tipoV: [],
            cantT: 0,
            cantM: 0,
            cantC: 0,
            cantP: 0,
            empresas: [],
            typo: '',
            solicitante: '',
            baseActu: '',
            empresaActu: '',
            viajesDiarios: [],
            isLoading: true
        };
        this.handleChangeE = this.handleChangeE.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.handleVehiculoViaje = this.handleVehiculoViaje.bind(this);
        this.handleSave = this.handleSave.bind(this);
    }

    componentDidMount() {
        firebase.database().ref('Bases').once('value').then(snap => {
            let bases = [];
            snap.forEach(element => {
                let datos = element.val();
                datos.key = element.key;
                bases.push(datos);
            });
            firebase.database().ref('Tipos_Vehiculos').once('value').then(snap => {
                let tipoV = [];
                snap.forEach(element => {
                    let data = element.val();
                    tipoV.push(data);
                });
                firebase.database().ref('Empresa').once('value').then(snap => {
                    let empresas = [];
                    snap.forEach(element => {
                        let data = element.val();
                        data.key = element.key;
                        empresas.push(data);
                    });
                    this.setState({ empresas, bases, tipoV }, () => {
                        this.contarVehi();
                        this.obteViajes();
                    });
                });
            });
        });
    }

    handleChange(event) {
        const selectedBase = event.target.value;
        this.setState({ baseActu: selectedBase, empresaActu: '', isLoading: true }, () => {
            //console.log('Base seleccionada:', selectedBase);
            this.obteViajes();
            this.contarVehi();
        });
    }

    handleChangeE(event) {
        const selectedEmpresa = event.target.value;
        this.setState({ empresaActu: selectedEmpresa, baseActu: '', isLoading: true }, () => {
            //console.log('Empresa seleccionada:', selectedEmpresa);
            this.obteViajes();
            this.contarVehi();
        });
    }

    contarVehi = () => {
        let { baseActu } = this.state;
        firebase.database().ref('LaboresEmpresa').on('value', data => {
            let taxi = 0;
            let priva = 0;
            let micro = 0;
            let coaster = 0;
            data.forEach(element => {
                let objeCont = element.val();
                if (objeCont.base === baseActu || baseActu === '') {
                    if (objeCont.tipoV === 'Taxi') {
                        taxi += 1;
                    }
                    if (objeCont.tipoV === 'Microbus') {
                        micro += 1;
                    }
                    if (objeCont.tipoV === 'Privado') {
                        priva += 1;
                    }
                    if (objeCont.tipoV === 'Coaster') {
                        coaster += 1;
                    }
                }
            });

            this.setState({ cantT: taxi, cantM: micro, cantP: priva, cantC: coaster });
        });
    }

    obteViajes = async () => {
        let { bases, baseActu, empresaActu } = this.state;
        let date = new Date();
        let fechaBusqueda = new Date(date.getFullYear() + '/' + (date.getMonth() + 1) + '/' + date.getDate());
        //console.log("Fecha de búsqueda:", fechaBusqueda);

        try {
            const snapshot = await firebase.database().ref('ProgramacionDia').once('value');
            let viajesDiarios = [];
            let i = 0;

            const baseMap = new Map(bases.map(base => [base.key, base]));

            snapshot.forEach(element => {
                let viajes = element.val();
                let fechaRegistro = new Date(viajes.fecha);
                if (fechaRegistro.getTime() === fechaBusqueda.getTime()) {
                    let validoBase = baseActu === viajes.baseI || baseActu === '';
                    let validoEmpresa = empresaActu === viajes.solicitante || empresaActu === '';

                    if (validoBase && validoEmpresa && viajes.estado === 'Pendiente') {
                        let baseInicio = baseMap.get(viajes.baseI);
                        let baseDestino = baseMap.get(viajes.baseF);
                        viajes.baseInicio = baseInicio;
                        viajes.baseDestino = baseDestino;
                        viajes.vehiculo = 'Microbus';
                        viajes.key = element.key;
                        viajesDiarios.push(viajes);
                        this.darValores(viajes, i);
                        i++;
                    }
                }
            });

            viajesDiarios.sort((a, b) => {
                let [horaA, minutoA] = a.horaInicio.split(':').map(Number);
                let [horaB, minutoB] = b.horaInicio.split(':').map(Number);
                return (horaA * 60 + minutoA) - (horaB * 60 + minutoB);
            });

            this.setState({ viajesDiarios, isLoading: false });
        } catch (error) {
            console.error("Error fetching data:", error);
            this.setState({ isLoading: false });
        }
    }

    handleVehiculoViaje = (event, index) => {
        let id3 = 'sele' + index;
        let valores = this.state[id3];
        valores.vehiculo = event.target.value === "Ejecutivo" ? 'Privado' : event.target.value;
        this.setState({ [id3]: valores });
    }

    darValores(objeto, index) {
        let id3 = 'sele' + index;
        this.setState({ [id3]: objeto });
    }

    handleSave = (index, dataActual) => {
        let id3 = 'sele' + index;
        console.log(this.state[id3])
        firebase.database().ref('LaboresEmpresa').once('value').then(snap => {
            let menor = 999999999;
            let conduc = '';
            let tipoVe = '';
            let datoE = '';
            let noTipoVehiculo = false;
            let noBase = false;
            snap.forEach(element => {
                noTipoVehiculo = false;
                noBase = false;
                let data = element.val();
                if (dataActual.baseI === data.base) {
                    if (data.tipoV === this.state[id3].vehiculo) {
                        if (data.cooncordancia < menor) {
                            menor = data.cooncordancia;
                            conduc = data.emple;
                            tipoVe = data.tipoV;
                            datoE = element.key;
                        }
                    } else {
                        noTipoVehiculo = true;
                    }
                } else {
                    noBase = true;
                }
            });
            if (noTipoVehiculo !== true) {
                if (noBase !== true) {
                    firebase.database().ref('Empleados/' + conduc).once('value').then(data => {
                        let emple = data.val();
                        firebase.database().ref('Vehiculos/' + emple.vehiculo).once('value').then(dataV => {
                            let vehi = dataV.val();
                            firebase.database().ref('LaboresEmpresa').once('value').then(dataL => {
                                let labores = [];
                                dataL.forEach(element => {
                                    let emple = element.val();
                                    let numero = emple.cooncordancia;
                                    if (numero > menor && dataActual.baseI === emple.base) {
                                        emple.cooncordancia = numero - 1;
                                        labores.push(emple);
                                    } else {
                                        if (datoE !== element.key) {
                                            labores.push(emple);
                                        }
                                    }
                                });
                                let idCreado = firebase.database().ref().child('AsignacionViajes').push({
                                    emple: '',
                                    conduc,
                                    fecha: dataActual.fecha,
                                    estado: "true",
                                    prograP: dataActual.programacion,
                                    base: dataActual.baseI,
                                    baseF: dataActual.baseF,
                                    horaProgra: dataActual.horaInicio,
                                    tipoVe,
                                    horaIni: "",
                                    horaFin: "",
                                    movil: vehi.movil,
                                    viajeIniciado: false,
                                    viajeFinalizado: false,
                                    tipoViaje: 'comun',
                                    inicio: String(dataActual.baseInicio.latitud + ',' + dataActual.baseInicio.longitud),
                                    destino: String(dataActual.baseDestino.latitud + ',' + dataActual.baseDestino.longitud),
                                    nameIni: dataActual.baseInicio.Nombre,
                                    nameDes: dataActual.baseDestino.Nombre,
                                    tarifa: dataActual.tarifa !== undefined ? dataActual.tarifa : '',
                                    prograDia: dataActual.key,
                                    vehiculo: emple.vehiculo,
                                })

                                firebase.database().ref().child('LaboresEmpresa').set(labores)

                                firebase.database().ref().child('Empleados/' + conduc).update({
                                    viajeEmpresa: 'No disponible',
                                    ViajeActualE: idCreado.key
                                })
                                firebase.database().ref().child('ProgramacionDia/' + dataActual.key).update({
                                    estado: 'Asignado',
                                    Viaje: idCreado.key,
                                    conductor: conduc
                                })
                            })
                            Alert.success('Viaje asignado con éxito', { effect: 'genie', position: 'bottom-right', timeout: 2000 });
                        })
                    })
                } else {
                    Alert.warning('No posee vehiculos disponibles en esta base', { effect: 'genie', position: 'bottom-right', timeout: 2000 });
                }
            } else {
                Alert.warning('No posee vehiculos de este tipo disponibles para asignación', { effect: 'genie', position: 'bottom-right', timeout: 2000 });
            }
        })
    }

    render() {
        let { bases, tipoV, cantT, cantM, cantP, cantC, empresas, empresaActu, viajesDiarios, baseActu, isLoading } = this.state;
        return (
            <div>
                <div className="row">
                    <div className="col-12">
                        <form>
                            <div className="form-row align-items-center">
                                <div className="col-sm-1 my-1">
                                    <label className="text-gray">Filtros</label>
                                </div>
                                <div className="col-sm-2 my-1">
                                    <select value={empresaActu} onChange={this.handleChangeE} className="form-control bg-select my-1 mr-sm-2">
                                        <option value={''}>Todas las Empresas</option>
                                        {empresas.map((snap, index) => (
                                            <option key={'opcion3' + index} value={snap.key}>{snap.codigo_empresa}</option>
                                        ))}
                                    </select>
                                </div>
                                <div className="col-sm-2 my-1">
                                    <select value={baseActu} onChange={this.handleChange} className="form-control bg-select my-1 mr-sm-2">
                                        <option value={''}>Todas las bases</option>
                                        {bases.map((snap, index) => (
                                            <option key={'opcion2' + index} value={snap.key}>{snap.Nombre}</option>
                                        ))}
                                    </select>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>

                <div className="row">
                    <div className="col-12 col-sm-9 restinge" >
                        <div className="table-responsive">
                            <table className="table">
                                <thead>
                                    <tr>
                                        <th>Viaje</th>
                                        <th>Hora de recogimiento</th>
                                        <th>Origen</th>
                                        <th>Asignar seguridad</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {viajesDiarios.map((snap, index) => {
                                        if (!isLoading) {
                                            return (
                                                <tr key={index}>
                                                    {snap.tipo === 'pilotos' &&
                                                        <td><button style={{ width: 160 }} className="btn btn-purple">{snap.vuelo}</button></td>
                                                    }
                                                    {snap.tipo === 'tcs' &&
                                                        <td><button style={{ width: 160 }} className="btn btn-greenR">{snap.vuelo}</button></td>
                                                    }
                                                    {snap.tipo === 'pilotossap' &&
                                                        <td><button style={{ width: 160 }} className="btn btn-orange">{snap.vuelo}</button></td>
                                                    }
                                                    {snap.tipo === 'tcssap' &&
                                                        <td><button style={{ width: 160 }} className="btn btn-sap">{snap.vuelo}</button></td>
                                                    }
                                                    {snap.tipo === 'persTierr' &&
                                                        <td><button style={{ width: 160, backgroundColor: '#ff9900' }} className="btn btn-sap">{snap.vuelo}</button></td>
                                                    }
                                                    <td>{snap.horaInicio}</td>
                                                    <td>{snap.baseInicio.Nombre}</td>
                                                    <td>
                                                        <div className="width-select">
                                                            <select onChange={(event) => this.handleVehiculoViaje(event, index)} className="form-control bg-select">
                                                                {tipoV.map((snap, index) => (
                                                                    <option key={'opcion' + index} selected={snap.tipo === 'Microbus'} value={snap.tipo}>{snap.tipo}</option>
                                                                ))}
                                                            </select>
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <button onClick={() => this.handleSave(index, snap)} className="btn btn-small-green">+</button>
                                                    </td>
                                                </tr>
                                            );
                                        }
                                    })}
                                    {isLoading &&
                                        <tr>
                                            <td></td>
                                            <td></td>
                                            <td style={{ marginTop: '45%' }}><Pulse /></td>
                                        </tr>
                                    }
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <div className="col-12 col-sm-3">
                        <div className="col-12">
                            <h5 className="m-top-h5">Unidades Disponibles</h5>
                        </div>
                        <div className="col-12 bg-card">
                            <div className="col-12">
                                <div className="row mar-bottom">
                                    <div className="col-12 col-sm-4">
                                        <img src={TaxiIcon} className="m-top" width="65" height="42" />
                                    </div>
                                    <div className="col-12 col-sm-8 m-top">
                                        <h5 className="m-bottom-none">{cantT}</h5>
                                        <span className="text-info">Taxis</span>
                                    </div>
                                </div>
                            </div>
                            <div className="col-12">
                                <div className="row mar-bottom">
                                    <div className="col-12 col-sm-4 ">
                                        <img src={PrivadoIcon} className="m-top" width="65" height="42" />
                                    </div>
                                    <div className="col-12 col-sm-8 m-top">
                                        <h5 className="m-bottom-none">{cantP}</h5>
                                        <span className="text-info">Privados</span>
                                    </div>
                                </div>
                            </div>
                            <div className="col-12">
                                <div className="row mar-bottom">
                                    <div className="col-12 col-sm-4">
                                        <img src={MicroIcon} className="m-top" width="65" height="42" />
                                    </div>
                                    <div className="col-12 col-sm-8 m-top">
                                        <h5 className="m-bottom-none">{cantM}</h5>
                                        <span className="text-info">Microbuses</span>
                                    </div>
                                </div>
                            </div>
                            <div className="col-12">
                                <div className="row mar-bottom">
                                    <div className="col-12 col-sm-4">
                                        <img src={CoasterIcon} className="m-top" width="65" height="42" />
                                    </div>
                                    <div className="col-12 col-sm-8 m-top">
                                        <h5 className="m-bottom-none">{cantC}</h5>
                                        <span className="text-info">Coaster</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}
export default AsignaViaje;


// WEBPACK FOOTER //
// ./src/Components/Planificacion/asignacionViajes.js